import { Role } from "generated/graphql";
import querystring from "query-string";
import React from "react";
import { Redirect, Route, RouteProps } from "react-router";
import { PublicPaths } from "./Paths";
import { UserProvider } from "./UserProvider";

interface CustomRouteProps extends Omit<RouteProps, "component" | "render"> {
  roles?: Role[];
}

export function AdminRoute({ roles = [], ...props }: CustomRouteProps) {
  return <AuthenticatedRoute {...props} roles={[Role.ADMIN, ...roles]} />;
}

export function AuthenticatedRoute({ roles = [], ...props }: CustomRouteProps) {
  return (
    <Route {...props}>
      {renderProps => (
        <UserProvider>
          {({ user }) => {
            if (!(user && roles.every(role => user.roles.includes(role)))) {
              return (
                <Redirect
                  to={{
                    pathname: PublicPaths.LogIn,
                    search: querystring.stringify({
                      ReturnUrl:
                        renderProps.location.pathname +
                        renderProps.location.search,
                    }),
                  }}
                />
              );
            }
            return props.children instanceof Function
              ? props.children(renderProps)
              : props.children;
          }}
        </UserProvider>
      )}
    </Route>
  );
}

export function PublicRoute(props: CustomRouteProps) {
  // Provide a logged-in user if present, but do not require
  return (
    <Route {...props}>
      {renderProps => (
        <UserProvider>
          {() =>
            props.children instanceof Function
              ? props.children(renderProps)
              : props.children
          }
        </UserProvider>
      )}
    </Route>
  );
}
